import React from 'react';
import './container.css';

const Container = ({ children }) => {
  return <div className="main_container">{children}</div>;
};

export default Container;



// WEBPACK FOOTER //
// ./src/Components/Container/index.js